import { motion } from 'framer-motion';

export function QuestionCard({ number, question, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      whileHover={{ 
        scale: 1.01,
        transition: { duration: 0.2, ease: [0.22, 1, 0.36, 1] }
      }}
      transition={{ 
        duration: 0.5, 
        delay,
        ease: [0.22, 1, 0.36, 1]
      }}
      className="flex items-start gap-4 px-6 py-6 rounded-2xl item-border border-white/10 bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm transition-all hover:border-white/20"
    >
      <div className="flex items-center justify-center w-8 h-8 flex-shrink-0 rounded-full bg-primary/20">
        <span className="text-[#FD5B38] text-base font-normal">{number}</span>
      </div>
      <p className="text-muted-foreground text-base sm:text-lg pt-1">
        {question}
      </p>
    </motion.div>
  );
}
